import { getNavigationService } from "@/infrastructure/di";

export function useNavigationService(): ReturnType<typeof getNavigationService> {
  return getNavigationService();
}
